import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'verifier_s_apsca_id_s'

export const dataPointDefinition = {
  retracedId: 'verifier_s_apsca_id_s',
  name: 'Verifier(s) APSCA ID(s)',
  description:
    'Enter phrase "Not Applicable" if the Verifier does not have APSCA (Association of Professional Social Compliance Auditors) Auditor Membership or the APSCA Code forbids you from entering your APSCA ID.',
  meta: {
    slcpMeta: {
      key: 'vd-veri-2',
      number: 'VD-VERI-10',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'vd-veri-2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34750,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
